import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aebb47a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalCreate",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = { class: "row mx-3 mx-lg-5 px-0 pb-4 gx-3 mt-5" }
const _hoisted_7 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_8 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_9 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_13 = { class: "row mx-3 mx-lg-5 px-0 pb-4 gx-3" }
const _hoisted_14 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_15 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = { class: "row mb-5 mx-3 mx-lg-5 px-0 gx-3" }
const _hoisted_19 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_20 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_21 = { class: "row ps-3 mx-0 col-lg-8 mt-2 d-flex" }
const _hoisted_22 = { class: "form-check col-lg-3" }
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id"]
const _hoisted_25 = { class: "form-check col-lg-6" }
const _hoisted_26 = ["for"]
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "row mx-3 mx-lg-5 px-0 pb-4 gx-3" }
const _hoisted_29 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_30 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = {
  class: "form-check-label fs-7 text-nowrap",
  for: "inviteOnlyGroup"
}
const _hoisted_33 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_34 = {
  class: "modal fade",
  id: "modalCreateConfirm",
  tabindex: "-4",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "modal-dialog modal-lg" }
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = { class: "modal-header" }
const _hoisted_38 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_40 = { class: "row mx-lg-0 p-4 gx-3 border-bottom" }
const _hoisted_41 = { class: "w-max-content col-lg-3" }
const _hoisted_42 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_43 = { class: "col-lg-12" }
const _hoisted_44 = { class: "row mx-lg-0 p-4 gx-3 border-bottom" }
const _hoisted_45 = { class: "w-max-content col-lg-3" }
const _hoisted_46 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_47 = { class: "col-lg-12 text-break break-spaces" }
const _hoisted_48 = { class: "row mx-lg-0 p-4 gx-3" }
const _hoisted_49 = { class: "w-max-content col-lg-3" }
const _hoisted_50 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_51 = { class: "col-lg-12" }
const _hoisted_52 = { class: "row mx-lg-0 p-4 gx-3" }
const _hoisted_53 = { class: "w-max-content col-lg-3" }
const _hoisted_54 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_55 = { class: "col-lg-12" }
const _hoisted_56 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_57 = {
  class: "modal fade",
  id: "successCreateGroup",
  tabindex: "-1",
  "aria-labelledby": "successCreateGroup",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog" }
const _hoisted_59 = { class: "modal-content" }
const _hoisted_60 = { class: "modal-header" }
const _hoisted_61 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmModal"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_63 = { class: "" }
const _hoisted_64 = { class: "text-center my-4" }
const _hoisted_65 = { class: "d-flex justify-content-center pb-4 modal-footer" }

import { required, maxLength, minLength } from '@vuelidate/validators'
import { ref, computed, onMounted, nextTick } from 'vue'
import useVuelidate from '@vuelidate/core'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'
import { translate } from '@/languages/i18n'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'
import groupsService from '@/services/groups.service'
import { REGEX_EMOJI } from '@/constants/regex'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'
import { customMaxLength, scrollToErrors } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const loadingCreate = ref<boolean>(false)
const createFailed = ref<boolean>(false)
const formData = ref({
  name: '',
  information: '',
  published: true,
  invitation_group: false,
})

const modalCreate = ref()
const modalConfirm = ref()
const modalComplete = ref()
onMounted(() => {
  modalCreate.value = new Modal(document.getElementById('modalCreate'))
  modalConfirm.value = new Modal(document.getElementById('modalCreateConfirm'))
  modalComplete.value = new Modal(document.getElementById('successCreateGroup'))
})

const rules = computed(() => {
  return {
    name: {
      required,
      maxLength: (value: string) => customMaxLength(value, 30),
      minLength: minLength(1),
    },
    information: {
      maxString: (value: string) => customMaxLength(value, 200),
    },
    published: { required },
  }
})
const v$ = useVuelidate(rules, formData)
const loading = ref(false)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  loading.value = true

  isCheckedNGKeyName.value = false
  isCheckedNGKeyInfo.value = false
  await checkNGKeyName()
  await checkNGKeyInfo()
  while (!isCheckedNGKeyName.value || !isCheckedNGKeyInfo.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (v$.value.$invalid || ngKeyName.value || ngKeyInfo.value) {
    loading.value = false
    nextTick(() => {
      scrollToErrors('.invalid-feedback', '#modalCreate')
    })
    return
  }
  modalCreate.value.hide()
  modalConfirm.value.show()
  loading.value = false
}

const createAGroup = async () => {
  loadingCreate.value = true
  const payload = {
    id: route.params?.id,
    params: {
      group_type: '3',
      ...route.query,
      keyword_name: route.query?.keyword_name || '',
      keyword_created_name: route.query?.keyword_created_name || '',
      published: route.query?.published ? '' : true,
      page_of_number: route.query?.page_of_number || 30,
    },
  }
  try {
    const response = await groupsService.createGroupApi(route.params?.id, { create_by_community_admin: true, group: formData.value })
    if (response?.status === 200) {
      createFailed.value = false

      v$.value.$reset()
      Object.assign(formData.value, {
        name: '',
        information: '',
        published: true,
        invitation_group: false,
      })
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_GROUPS, {
        id: route.params?.id,
        params: {
          group_type: '3',
          ...route.query,
          page: route.query?.page || 1,
          page_of_number: route.query?.page_of_number || 30,
          published: route.query?.published ? '' : true,
          create_by_admin: true,
        },
      })
    } else {
      createFailed.value = true
    }
    modalConfirm.value.hide()
    modalComplete.value.show()
    loadingCreate.value = false
  } catch (error) {
    console.log(error)
    loadingCreate.value = false
    createFailed.value = true
  }
}

const resetForm = () => {
  v$.value.$reset()
  Object.assign(formData.value, {
    name: '',
    information: '',
    published: true,
    invitation_group: false,
  })
  ngKeyName.value = false
  ngKeyInfo.value = false
}

const isCheckedNGKeyName = { value: false }
const ngKeyName = ref<boolean>(false)
const checkNGKeyName = debounce(async () => {
  const queryData = { sentence: v$.value.name.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyName.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyName.value = true
  }
}, 200)

const isCheckedNGKeyInfo = { value: false }
const ngKeyInfo = ref<boolean>(false)
const checkNGKeyInfo = debounce(async () => {
  const queryData = { sentence: v$.value.information.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyInfo.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyInfo.value = true
  }
}, 200)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Button, {
      title: _unref(translate)('addGroup'),
      "data-bs-Toggle": "modal",
      "data-bs-target": "#modalCreate",
      type: 'secondary',
      onClick: resetForm
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('createGroupAmin')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetForm
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
            class: "content"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('groupName')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyName) && _unref(checkNGKeyName)(...args))),
                    class: _normalizeClass(['form-control', ngKeyName.value || _unref(v$).name.$error ? 'is-invalid' : '']),
                    id: "groupName",
                    placeholder: _unref(translate)('placeholder')
                  }, null, 42, _hoisted_11), [
                    [
                      _vModelText,
                      _unref(v$).name.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (ngKeyName.value && !_unref(v$).name.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: 'groupName',
                    params: [1, 30],
                    validator: _unref(v$).name.$errors[0]?.$validator
                  }, null, 8, ["validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('explanatoryText')), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("textarea", {
                    type: "text",
                    class: _normalizeClass(['form-control', ngKeyInfo.value || _unref(v$).information.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).information.$model) = $event)),
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyInfo) && _unref(checkNGKeyInfo)(...args))),
                    id: "information"
                  }, null, 34), [
                    [
                      _vModelText,
                      _unref(v$).information.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (ngKeyInfo.value && !_unref(v$).information.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: 'explanatoryText',
                    params: [200],
                    validator: _unref(v$).information.$errors[0]?.$validator
                  }, null, 8, ["validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(translate)('publicSettings')), 1),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: _ctx.public1
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.public1,
                      value: true,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_24), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('public')), 1)
                  ], 8, _hoisted_23)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: _ctx.private1
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.private1,
                      value: false,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_27), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('private')), 1)
                  ], 8, _hoisted_26)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)('inviteOnlyGroupSettings')), 1),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "inviteOnlyGroup",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.invitation_group) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, formData.value.invitation_group]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('inviteOnlyGroup')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(Button, {
                title: _unref(translate)('CloseButton'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                className: 'me-2 fw-bold',
                onClick: resetForm
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                disabled: loading.value,
                loading: loading.value,
                onClick: onSubmit,
                className: 'fw-bold'
              }, null, 8, ["title", "disabled", "loading"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("h5", _hoisted_38, _toDisplayString(_unref(translate)('createGroupAmin')), 1),
            _hoisted_39
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(translate)('groupName')), 1),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(formData.value.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(translate)('explanatoryText')), 1),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(formData.value.information), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(translate)('publicSettings')), 1),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, _toDisplayString(formData.value.published ? _unref(translate)('public') : _unref(translate)('private')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("label", _hoisted_53, _toDisplayString(_unref(translate)('inviteOnlyGroupSettings')), 1),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, _toDisplayString(formData.value.invitation_group ? _unref(translate)('inviteOnlyGroup') : _unref(translate)('generalGroup')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(Button, {
                title: _unref(translate)('postEdit'),
                type: 'secondary',
                dataBsToggle: 'modal',
                dataBsTarget: '#modalCreate',
                className: 'me-2 fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                type: 'secondary',
                title: _unref(translate)('signUp'),
                onClick: createAGroup,
                className: 'fw-bold',
                disabled: loadingCreate.value
              }, null, 8, ["title", "disabled"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("h5", _hoisted_61, _toDisplayString(_unref(translate)('createGroupAmin')), 1),
            _hoisted_62
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("p", _hoisted_64, _toDisplayString(createFailed.value ? _unref(translate)('errorCreateGroup') : _unref(translate)('groupCreated')), 1)
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})